module.exports = __webpack_public_path__ + "img/button_questionnaire3@2x.45d9a33e.png";